import { render, staticRenderFns } from "./editDistributionMode.vue?vue&type=template&id=78bd2354"
import script from "./editDistributionMode.vue?vue&type=script&lang=js"
export * from "./editDistributionMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports